import { useState } from "react";
import MembershipWrite from "./MembershipWrite";
import MembershipRankTrack from "./MembershipRankTrack";
import MembershipRequestView from "./MembershipRequestView";
import MembershipPointCharge from "./MembershipPointCharge";

const TABS = [
    { id: "write", label: "글쓰기 멤버쉽", Component: MembershipWrite },
    { id: "rank", label: "순위 조회 추적 이용권", Component: MembershipRankTrack },
    { id: "request", label: "의뢰열람 이용권", Component: MembershipRequestView },
    // { id: "point", label: "포인트충전", Component: MembershipPointCharge },
];

const Membership = () => {
    const [activeTab, setActiveTab] = useState(TABS[0].id);
    const ActiveComponent = TABS.find((tab) => tab.id === activeTab)?.Component ?? MembershipWrite;

    return (
        <div className="vh-content">
            <div className="section-area">
                <div className="section-header">
                    <div className="section-category">
                        <ul>
                            {TABS.map((tab) => (
                                <li
                                    key={tab.id}
                                    className={activeTab === tab.id ? "active" : ""}
                                    onClick={() => setActiveTab(tab.id)}
                                >
                                    {tab.label}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="section-content">
                    <ActiveComponent />
                </div>
            </div>
        </div>
    );
};

export default Membership;
